import { styled } from '@linaria/react';

export const Link = styled.a`
  color: inherit;
`;

export const ConditionTooltipContent = styled.div`
  min-width: 15rem;
`;
